<template>
    <div class="status-icon" :class="[statusClass, positionClass]">
        <SvgIcon name="unit__reefer" class="icon status-icon__icon" :style="{width: 10 +'px', height: 10 +'px'}"/>
    </div>
</template>

<script>
import unitMixin from "@/mixins/unitMixin";

export default {
    name: "UnitsList_unit_video_status",
    mixins: [unitMixin],
    props: {
        unitId: Number,
        position:{
            type: String,
            default: () => { return 'tl' }
        }
    },
    components: {
    },
    data() {
        return {
            statuses: {
                online: 'ok',
                offline: 'error',
                standby: 'warning',
            }
        }
    },
    computed: {
        isReefer(){
            return this.unit?.hw_type == 'globe_tracker'
        },
        statusClass(){
            return 'status-icon__'+(this.isReefer ? 'ok' : 'null')
        },
        positionClass(){
            return 'status-icon__position-' + this.position
        }
    },
}
</script>

<style scoped>

</style>